module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Italic.2412c72a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Italic.woff2
// module id = 524
// module chunks = 0